import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STORE_MODULE_NAME } from './const';
import { State as StateType } from './types';

const Activity = namespace(STORE_MODULE_NAME);

@Component
export default class PageActivityCardMixin extends Vue {
  // Vuex
  @Activity.State
  activity: StateType['activity'];

  // AsyncData
  async asyncData({ store, route }: any) {
    await store.state[STORE_MODULE_NAME].request;
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/card/common.ts